<dss-shared-lib-map-container shouldShowActiveRestrictionsLayer />
